export default "__VITE_ASSET__1nNh3B1i__"